import React from 'react';
import PropTypes from 'prop-types';
import styles from './css/HomeCampaign.module.css';


function HomeCampaign(props) {
  const { activeCampaign } = props;

  const { name, mainImage, mainMobileImage, checkoutUrl } = activeCampaign || {};

  return (
    <main className={styles.homePageCampaign}>
      <a className={styles.fullWidthDesktop} href={checkoutUrl}>
        <img
          alt={name} src={mainImage}
        />
      </a>
      <a className={styles.fullWidthMobile} href={checkoutUrl}>
        <img
          alt={name} src={mainMobileImage}
        />
      </a>
    </main>
  );
}

HomeCampaign.propTypes = { activeCampaign: PropTypes.object };

HomeCampaign.defaultProps = { activeCampaign: undefined };

export default HomeCampaign;
